import { useQuery } from '@tanstack/vue-query';
import { validatorFactory } from '@laam/lib/validator';
import type { Article } from '~/types/blogs';
import { ArticleSchema } from '~/types/blogs';
import axios from 'axios';
import * as Sentry from '@sentry/vue';

const articleValidator = validatorFactory<Article>(ArticleSchema);

export const useArticlesQuery = (articleId: string) => {
	const API_URL = `https://fortunate-captain-8b9931b9be.strapiapp.com/api/articles?filters[handle][$eqi]=/${articleId}&populate=image`;
	const { data, isLoading, error, suspense } = useQuery({
		queryKey: ['articles', articleId],
		queryFn: async () => {
			try {
				const response = await axios.get(API_URL, {
					headers: {
						Authorization: `Bearer ${useRuntimeConfig().public.strapiBearerToken}`,
					},
				});

				if (response.status === 200) {
					try {
						return articleValidator.verify(response.data.data[0]);
					} catch (e) {
						const err = new Error('Failed to verify article data');
						Sentry.captureException(`${err}`, (scope) => {
							scope.setContext('errors', {
								error: e,
							});
							return scope;
						});
						throw err;
					}
				}
				const error = new Error('Failed to fetch article data');
				Sentry.captureException(`${error}`, (scope) => {
					scope.setContext('error', { error: error });
					return scope;
				});
				throw error;
			} catch (error: any) {
				Sentry.captureException(error);
				throw new Error(error.message ?? error.msg);
			}
		},
	});

	return { data, isLoading, error, suspense };
};
